// 通常需要支持小程序的都需要确保 WeixinJSBridgeReady
// 通常有页面跳转的都需要支持小程序
import { isEnvProd, isNodeProd } from './base/env'

// if (!isNodeProd()) {
//   import(/* webpackChunkName: "owl" */ './3rd-lib/owl')
// }
window.GUO = {}
import 'intersection-observer'
import './base/global'
import './decorator'
import Agent from './agent'
import User from './user'
import { reportInfo } from './owl'
import { I_MP_OAUTH } from './mp-oauth'

type CustomEvent = Event & {
  detail?: {
    top: number
  }
}

const isProd = isEnvProd() && isNodeProd()

try {
  window.owl &&
    window.owl('setDimension', {
      uuid: User.uuid,
      userId: User.userId,
      version: Agent.version,
      osVersion: Agent.osVersion,
      appnm: Agent.appnm,
    })
} catch (err) {
  console.error(err)
}
// config owl

// config lx
window.LX_PAGE_LAB_CUSTOM = {}
// 设置 appnm 需要在灵犀初始化之前进行设置，否则可能会引起设置之前上报的数据的 appnm 与设置的 appnm 不一致
window.Analytics && window.Analytics('set', 'appnm', Agent.appnm)
if (!isProd) {
  window.Analytics && window.Analytics('config', 'isDev', true)
}

if (Agent.weixin || Agent.anyminiprogram) {
  window.$bus.$on('wxoauth-ready', (mpUserInfo: I_MP_OAUTH) => {
    const { openid, unionId } = mpUserInfo
    window.Analytics && window.Analytics('set', 'wxid', openid)
    unionId && window.Analytics && window.Analytics('set', 'wxunionid', unionId)
  })
}

window.addEventListener('KNB:safeAreaInsetsChanged', (e: CustomEvent) => {
  console.log('safeAreaInsetsChanged', e.detail)
  const detail = e.detail || { top: 0 }
  // 容器自定义事件的额外数据通过 detail 字段传递
  const el = document.querySelector('html') as HTMLElement
  if (Agent.iphone && Agent.dianping) {
    if (detail.top >= 64) {
      el.classList.add('dp-notitlebar')
    } else {
      el.classList.remove('dp-notitlebar')
    }
  } else if (detail.top >= 44) {
    el.classList.add('notitlebar')
  }
})

if (!Agent.pc) {
  // 用于修正部分设备的fontSize与width vw实际长度不同问题
  try {
    const el = document.createElement('div')
    el.setAttribute('id', 'testvw')
    el.setAttribute('style', 'position: fixed; top: -999px; width: 10vw; height: 10vw; font-size: 10vw;')
    document.body.appendChild(el)
    const computedStyle = window.getComputedStyle(el)
    const computedWidth = Number(parseFloat(computedStyle.getPropertyValue('width')).toFixed(1))
    const computedFontSize = Number(parseFloat(computedStyle.getPropertyValue('font-size')).toFixed(1))
    if (computedWidth !== computedFontSize) {
      reportInfo({
        name: 'font-size vw !== width vw',
        msg: `width vw: ${computedWidth}; font-size vs: ${computedFontSize};`,
        global: true,
      })
      const htmlEl = document.querySelector('html') as HTMLElement
      htmlEl.setAttribute('style', `font-size: ${(10 / computedFontSize) * computedWidth}vw`)
    }
    document.body.removeChild(el)
  } catch (err) {
    // do nothing
  }
}
